import { apiClient } from "@/core/api/ApiClient";
import { EntityType, WheelOperationDto } from "@/core/api/generated/v1";

import BaseEntitiesDeleteModal, {
  BaseEntitiesDeleteModalInheritableProps,
} from "../components/BaseEntitiesDeleteModal";

export interface OwnProps {
  entities: WheelOperationDto[];
}

type Props = OwnProps & BaseEntitiesDeleteModalInheritableProps;

export default function WheelOperationsDeleteModal({ entities, ...otherProps }: Props) {
  return (
    <BaseEntitiesDeleteModal
      cascadeActionDisplay={true}
      entityType={EntityType.WheelOperation}
      entities={entities}
      deleteFunc={async (params) => {
        await apiClient.wheelOperationsApi.apiV1WheelOperationsBulkDeleteDelete({
          nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
          entityBulkDeleteDto: {
            ids: params.entityIds,
            relatedEntitiesTypes: params.relatedEntitiesTypes,
          },
        });
      }}
      {...otherProps}
    />
  );
}
